import { type FetchResponse } from '@cian/http-api';
import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { type IComparisonActionResult, type IComparisonRequestParams } from './types';
import { EPropertyType } from '../../repositories/property-comparison/entities/v1_delete_from_comparison/DeleteFromComparisonRequest';
import { fetchDeleteFromComparison } from '../../repositories/property-comparison/v1/delete-from-comparison';
import { type TDeleteFromComparisonResponse } from '../../repositories/property-comparison/v1/delete-from-comparison/types';

const DOMAIN = 'src/shared/services/propertyComparison/removeNewbuildingFromComparison';

export async function removeNewbuildingFromComparison({
  httpApi,
  logger,
  newbuildingId,
}: IComparisonRequestParams): Promise<IComparisonActionResult> {
  let result: FetchResponse<TDeleteFromComparisonResponse>;

  try {
    result = (await fetchDeleteFromComparison({
      httpApi,
      parameters: {
        propertyType: EPropertyType.Newbuilding,
        propertyId: newbuildingId,
      },
    })) as FetchResponse<TDeleteFromComparisonResponse>;
  } catch (error) {
    logger.error(
      new UnknownError({
        message: 'Ошибка при удалении ЖК из сравнения',
        domain: DOMAIN,
        details: error as UnknownError,
      }),
    );

    throw error;
  }

  const { statusCode, response } = result;
  const responseData = response as IComparisonActionResult;

  if (statusCode !== 200) {
    const error = new HttpBadStatusCodeError({
      statusCode,
      message: responseData.message || responseData.text || 'Ошибка при удалении ЖК из сравнения',
      domain: DOMAIN,
    });

    logger.error(error);

    throw error;
  }

  return responseData;
}
